import {CommentBox} from '@github-ui/comment-box/CommentBox'
import {type MarkdownComposerRef, useMarkdownBody} from '@github-ui/commenting/useMarkdownBody'

import {forwardRef, useCallback, useEffect, useRef} from 'react'

const CommitCommentEditor = forwardRef<
  MarkdownComposerRef,
  {
    initialMarkdown?: string
    onCancel?: () => void
    onSave: (markdown: string, restMarkdownBody: () => void) => void
    referenceId: string
  }
>(({initialMarkdown, onCancel, onSave, referenceId}, ref) => {
  const commentBoxRef = useRef(null)

  const onChange = useCallback(() => {}, [])

  const {markdownBody, resetMarkdownBody, markdownValidationResult, handleMarkdownBodyChanged} = useMarkdownBody({
    commentBoxRef,
    markdownComposerRef: ref,
    onChange,
    onCancel: () => {},
    referenceId,
  })

  useEffect(() => {
    // Don't override the markdown saved in the session
    if (initialMarkdown && !markdownBody) {
      handleMarkdownBodyChanged(initialMarkdown)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialMarkdown])

  return (
    <CommentBox
      ref={commentBoxRef}
      validationResult={markdownValidationResult}
      onChange={handleMarkdownBodyChanged}
      onCancel={() => {
        handleMarkdownBodyChanged(initialMarkdown ?? '')
        onCancel && onCancel()
      }}
      onSave={() => onSave(markdownBody, resetMarkdownBody)}
      value={markdownBody}
    />
  )
})

CommitCommentEditor.displayName = 'CommitCommentEditor'
export {CommitCommentEditor}
